<main class="content-container" style="background-image: url(assets/RCN-Home-back.jpg);"
    *ngIf="roleId===adminRole || roleId===championRole || roleId === clientAdmin">
    <div class="div-banner" *ngIf="roleId===adminRole || roleId===championRole">
        <release-banner></release-banner>
    </div>

    <div class="home-landing-main-container">
        <div class="section-study-search study-sec" data-custom-parentid="Research Credit Navigator"
            data-custom-id="Research Credit Navigator" data-custom-bhvr="NAVIGATION">
            <div class="home-page-sec">
                <div class="home-rcn-sec">
                    <div class="text-rcn">Research Credit Navigator</div>
                    <div class="text-hub">Technology hub for the planning, execution, and documentation of research and
                        development tax credit projects</div>
                </div>

                <div *ngIf="roleId===championRole" class="select_search_by_radio_buttons_section">
                    <div class="" *ngFor="let option of studySearchOptions">
                        <input type="radio" name="searchStudyByRadioGroup" [checked]="option.isSelected"
                            (change)="setSearchByOption(option.optionId)">
                          <label>{{ option.optionName }}</label><br>
                    </div>
                </div>

                <form autocomplete="off" class="engagement-search-portion">
                    <section class="search-input-container"
                        *ngIf="searchStudyBy === searchStudyOption.study && roleId !== clientAdmin">
                        <div class="input-with-search">
                            <input #engagementSearch class="champion-search-input  search-box-custom"
                                placeholder="Search by study" type="text" required name="focus"
                                [container]="'#engagementTypeAhead'" no-special-chars="#!$@%^<>+="
                                [kpmgUiTypeahead]="searchEngagementsStream" [resultTemplate]="studyResultTemplate"
                                [editable]="false" (selectItem)="onEngagementFilter($event)"
                                [inputFormatter]="engagementFormatter" (keydown.enter)="$event.preventDefault()"
                                (clickOutside)="engagementOutsideClick()">
                            <button class="cross-icon" type="reset" (click)="clearSearch()"></button>
                            <i class="fa-solid fa-search" aria-hidden="true"></i>
                        </div>
                        <ng-template #studyResultTemplate let-r="result" let-t="term">
                            <kpmg-ui-highlight class="search-engagement__name" [result]="r.engagementName" [term]="t">
                            </kpmg-ui-highlight>&nbsp;
                            <kpmg-ui-highlight class="search-engagement__clientname"
                                [result]=" '(' + r.clientName + ')'" [term]="t">
                            </kpmg-ui-highlight>&nbsp; &nbsp;
                            <kpmg-ui-highlight class="search-engagement__no eng-num-style" [result]="r.engagementNumber"
                                [term]="t">
                            </kpmg-ui-highlight>

                        </ng-template>
                        <div id="no-results" class="alert alert-danger no-eng-alert" role="alert" *ngIf="noResults">
                            <i class="fas fa-exclamation-triangle"></i> No studies found
                        </div>
                    </section>

                    <section class="search-input-container"
                        *ngIf="searchStudyBy === searchStudyOption.client && roleId !== clientAdmin">
                        <div class="input-with-search">
                            <input #clientSearch class="champion-search-input  search-box-custom"
                                placeholder="Search for a Client" type="text" required name="focus"
                                [container]="'#clientTypeAhead'" no-special-chars="#!$@%^<>+="
                                [kpmgUiTypeahead]="searchClientsStream" [resultTemplate]="rt" [editable]="false"
                                (selectItem)="onClientSelected($event.item, false)" [inputFormatter]="clientFormatter"
                                (keydown.enter)="keydownEnterClick($event)" (clickOutside)="engagementOutsideClick()">
                            <button class="cross-icon" type="reset" (click)="clearSearch()"></button>
                            <i class="fa-solid fa-search" aria-hidden="true"></i>
                        </div>
                        <ng-template #rt let-r="result" let-t="term">
                            <div class="dropdown-items">
                                <kpmg-ui-highlight class="search-client-name" [result]="r.clientName" [term]="t">
                                </kpmg-ui-highlight>
                                <kpmg-ui-highlight class="search-client-ref-id"
                                    [result]="'Master ref. ' + masterRefIdNull(r.masterRefId)" [term]="t">
                                </kpmg-ui-highlight>
                            </div>
                        </ng-template>
                        <div id="no-results" class="alert alert-danger no-eng-alert" role="alert" *ngIf="noResults">
                            <i class="fas fa-exclamation-triangle"></i> No clients found
                        </div>
                    </section>

                    <div class="client-selected" *ngIf="selectedClient != null && selectedClient != undefined">
                        <div class="client-info">
                            <span class="selected-client-name">{{selectedClient.clientName}}</span>
                            <span class="selected-client-ref-id">(Master Ref.
                                {{masterRefIdNull(selectedClient.masterRefId)}})</span>
                            <div class="toggles-sec" *ngIf="roleId == clientAdmin">
                                <span class="toggle-container">
                                    <toggle-switch (toggleState)="includeArchiveToggleClick($event)"
                                        [switchState]="includeArchive">
                                    </toggle-switch>
                                    Show Archive
                                </span>
                            </div>
                        </div>
                        <div class="list-of-engagements">
                            <div class="engagement-card" *ngFor="let engagement of engagementsByClientId">
                                <div class="engagement-card-text">
                                    <span [ngClass]="includeArchive ? 'engagement-name archived' : 'engagement-name'"
                                        title="{{engagement.engagementName}}">
                                        {{engagement.engagementName}}
                                    </span>
                                    <span [ngClass]="includeArchive ? 'engagement-number archived' : 'engagement-name'"
                                        title="{{engagement.engagementNumber}}">
                                        ID. {{engagement.engagementNumber}}
                                    </span>
                                </div>
                                <button type='button' class="btn btn-link button-view-study"
                                    (click)="onViewStudyClick(engagement)">
                                    View study
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="just-line"></div>

                    <div class="toggles-sec"
                        *ngIf="roleId !== clientAdmin && (selectedClient == null || selectedClient == undefined)">
                        <span class="toggle-container">
                            <toggle-switch (toggleState)="externalModeToggleClick($event)" [switchState]="externalMode">
                            </toggle-switch>
                            External Mode
                        </span>
                        <span class="toggle-container">
                            <toggle-switch (toggleState)="includeArchiveToggleClick($event)"
                                [switchState]="includeArchive">
                            </toggle-switch>
                            Show Archive
                        </span>

                    </div>

                    <div class="comment-sec" *ngIf="roleId !== clientAdmin">
                        <div class="comment-line">
                            <span class="comment-text">Onboard clients to Digital Gateway for enhanced client
                                experience.</span>
                            <span class="comment-link" (click)="onboardClientClick()">Onboard new client<i
                                    class="icon fa-solid fa-arrow-up-right-from-square"></i></span>
                        </div>
                        <div class="comment-line">
                            <span class="comment-text">
                                Alternatively, add a client to create a study here.
                            </span>
                            <span class="comment-link" (click)="createNewEngagementClick()">
                                Create new study<i class="icon fa-solid fa-arrow-right"></i>
                            </span>
                        </div>
                    </div>

                </form>

            </div>
        </div>

        <div class="section-study-favourite">
            <rcn-favorite-studies *ngIf="!externalMode" class="section-fav-study-container"
                [favoriteStudies]="favoriteStudies">
            </rcn-favorite-studies>
        </div>
    </div>

    <div class="disclaimer-holder disclaimer-notice-container">
        &copy; {{ currentDate | date:'yyyy'}} KPMG LLP, a Delaware limited liability partnership and a member
        firm of the KPMG global organization of independent member firms affiliated with KPMG International
        Limited, a private English company limited by guarantee. All rights reserved.
        For more detail about the structure of the KPMG global organization, please click
        <a class="footer-policy-link" rel="noopener noreferrer" target="_blank"
            href="https://home.kpmg/xx/en/home/misc/governance.html" alt="KPMG Intranet Usage Policy">here</a>.
        For internal use only. Use of this system is governed by the
        <a class="footer-policy-link" rel="noopener noreferrer" target="_blank"
            href="https://kpmgus.sharepoint.com/sites/US-OI-INF-policycenter/SitePages/Human%20Resources/KPMG-LLP-(US)-Firm-Personnel-Data-Privacy-Notice.aspx"
            alt="KPMG Intranet Usage Policy">
            KPMG LLP (US) – Firm Personnel Data Privacy Notice</a>.
    </div>
</main>
<main class="content-container" *ngIf="roleId===0">
    <div class="home-page-sec">
        <section class="home-page-title">
            <h1>Research Credit Navigator</h1>
        </section>
        <section class="nodata-message-center">
            <h2>No Engagements or Surveys assigned yet.</h2>
        </section>
        <section class="disclaimer-holder disclaimer-notice-container">
            &copy; {{ currentDate | date:'yyyy'}} KPMG LLP, a Delaware limited liability partnership and a member
            firm of the KPMG global organization of independent member firms affiliated with KPMG International
            Limited, a private English company limited by guarantee. All rights reserved.
            For more detail about the structure of the KPMG global organization, please click
            <a class="footer-policy-link" rel="noopener noreferrer" target="_blank"
                href="https://home.kpmg/xx/en/home/misc/governance.html" alt="KPMG Intranet Usage Policy">here</a>.
            For internal use only. Use of this system is governed by the
            <a class="footer-policy-link" rel="noopener noreferrer" target="_blank"
                href="https://kpmgus.sharepoint.com/sites/US-OI-INF-policycenter/SitePages/Human%20Resources/KPMG-LLP-(US)-Firm-Personnel-Data-Privacy-Notice.aspx"
                alt="KPMG Intranet Usage Policy">
                KPMG LLP (US) – Firm Personnel Data Privacy Notice</a>.
        </section>
    </div>
</main>
<activity-monitor *ngIf="isMainAppInstance" [timersEnabled]="true"></activity-monitor>
<session-mgmt *ngIf="isMainAppInstance"></session-mgmt>
<storage-monitor *ngIf="isMainAppInstance"></storage-monitor>